webpackJsonp([37],{

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentDetailCard_vue__ = __webpack_require__(246);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2027960_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentDetailCard_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d2027960"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentDetailCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2027960_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentDetailCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDRweCIgaGVpZ2h0PSI0NHB4IiB2aWV3Qm94PSIwIDAgNDQgNDQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5QbGF5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBsYXkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIwLjUiIGN4PSIyMiIgY3k9IjIyIiByPSIyMiI+PC9jaXJjbGU+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNy4wNDIwMzEzLDE1LjI4MjI3NTMgTDE3LjA0MjAzMTMsMjguNzE3NzgxNCBDMTcuMDQyMDMxMywyOC44ODM0NjY4IDE3LjE3NjM0NTksMjkuMDE3NzgxNCAxNy4zNDIwMzEzLDI5LjAxNzc4MTQgQzE3LjM5MjIyNywyOS4wMTc3ODE0IDE3LjQ0MTYyMDQsMjkuMDA1MTg2NCAxNy40ODU2ODcsMjguOTgxMTUwMSBMMjkuODAxNTY3NiwyMi4yNjMzOTcgQzI5Ljk0NzAyMjEsMjIuMTg0MDU4MiAzMC4wMDA2MTk0LDIyLjAwMTgyNzIgMjkuOTIxMjgwNiwyMS44NTYzNzI3IEMyOS44OTM2OTcsMjEuODA1ODAyOCAyOS44NTIxMzc1LDIxLjc2NDI0MzMgMjkuODAxNTY3NiwyMS43MzY2NTk3IEwxNy40ODU2ODcsMTUuMDE4OTA2NiBDMTcuMzQwMjMyNSwxNC45Mzk1Njc4IDE3LjE1ODAwMTUsMTQuOTkzMTY1MiAxNy4wNzg2NjI3LDE1LjEzODYxOTcgQzE3LjA1NDYyNjMsMTUuMTgyNjg2MyAxNy4wNDIwMzEzLDE1LjIzMjA3OTYgMTcuMDQyMDMxMywxNS4yODIyNzUzIFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBvcGFjaXR5PSIwLjkwMDAwMDAzNiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Utility__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ContentDetailCard",
  props: {
    closePopupEvent: {
      type: Function
    },
    cardContent: {
      type: Object
    },
    category: {
      type: String
    }
  },
  data: function data() {
    return {
      cardHeight: 500,
      cardTabs: ["More", "About", "Episodes", "Overview"],
      activeTabName: "Overview",
      aboutCardTabs: ["Trailers", "Cast&crew", "Reviews", "Posters"],
      activeAboutTabName: "Trailers",
      showPurchaseDetail: false,
      purchaseDetails: null,
      languages: [],
      showPurchaseButton: true,
      contentPrice: null,
      progress: null
    };
  },

  components: {
    CardDisLikeBtn: function CardDisLikeBtn() {
      return __webpack_require__.e/* import() */(23/* duplicate */).then(__webpack_require__.bind(null, 250));
    },
    CardLikeBtn: function CardLikeBtn() {
      return __webpack_require__.e/* import() */(22/* duplicate */).then(__webpack_require__.bind(null, 251));
    },
    Share: function Share() {
      return __webpack_require__.e/* import() */(24/* duplicate */).then(__webpack_require__.bind(null, 307));
    }
  },
  watch: {
    cardContent: function cardContent() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("closeAllArrow");
      this.purchaseDetails = null;
      this.progress = this.cardContent.progress ? this.cardContent.progress : null;

      if (this.cardContent.purchaseDetails) {
        this.purchaseDetails = this.cardContent.purchaseDetails;
      }
      this.showArrow();
      this.getLanguage();
      this.getContentCurrency();
      setTimeout(function () {
        _this.reset();
      }, 100);
    },
    currency: function currency() {
      if (this.currency) {
        this.getContentCurrency();
      }
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("closeAllArrow");
    //
    this.getLanguage();
    this.fetchCardHeight();
    this.checkContentType();

    if (this.cardContent.purchaseDetails) {
      this.purchaseDetails = this.cardContent.purchaseDetails;
      // console.log('purchase details', this.purchaseDetails);
    }

    __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$on("ticketStatus-" + this.cardContent.contentid, function (data) {
      _this2.showPurchaseButton = false;
      // this.checkUserBoughtTicket();
      if (data) {
        _this2.purchaseDetails = data;
        _this2.cardContent.ticketStatus = true;
        _this2.cardContent.purchaseDetails = data;
      }
    });
    if (this.subscriberid) {
      this.getCardProgress();
    }
    if (this.currency) {
      this.getContentCurrency();
    }
  },
  mounted: function mounted() {
    this.showArrow();
    // $('html,body').animate({scrollTop: $(`${this.category}-${this.cardContent.contentid}`).offset().top},800);
    var elmnt = document.getElementById(this.category + "-" + this.cardContent.contentid);

    elmnt.scrollIntoView({ block: "start" });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["vendorid", "subscriberid", "currency"])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(["commitNewTicket"]), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["actListTicket"]), {
    getContentCurrency: function getContentCurrency() {
      this.contentPrice = this.getContentPrice(this.cardContent);
    },
    watchTrailer: function watchTrailer() {
      __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("showPlayer", this.cardContent, "T");
    },
    playContent: function playContent() {
      __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("showPlayer", this.cardContent);
    },
    getCardProgress: function getCardProgress() {
      var _this3 = this;

      var content = this.cardContent;
      var contentid = content.contentid;
      var contenttype = content.contenttype;
      // Create the firebase paths to fetch the data
      var path = this.vendorid + "/subscriber/" + this.subscriberid + "/content/" + contentid;

      __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref(path).on("value", function (snapshot) {
        if (snapshot.val()) {
          var response = snapshot.val();
          if ((response.status === "INPROGRESS" || response.status === "COMPLETED") && response.watchedduration > 9 && new Date(response.expiry) >= new Date()) {
            var duration = response.duration;
            var watched = response.watchedduration;
            var progress = watched / duration * 100;
            if (progress > 0 && progress < 100) {
              _this3.progress = progress;
            }
          } else if (response.status === "COMPLETED") {
            _this3.progress = null;
          } else {
            _this3.progress = null;
          }
        }
      });
    },
    formateDate: function formateDate() {
      var dateString = "";
      if (this.cardContent.purchaseDetails.expiry) {
        var fromDate = new Date(this.cardContent.purchaseDetails.expiry);
        var months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        dateString = fromDate.getDate() + " " + months[fromDate.getMonth()] + " " + fromDate.getFullYear();
      }
      return dateString;
    },
    getCurrency: function getCurrency(currency) {
      var str = "";
      switch (currency) {
        case "INR":
          str = "₹";
          break;
        default:
          str = "$";
          break;
      }
      return str;
    },
    toggleDetails: function toggleDetails() {
      if (!this.showPurchaseDetail) {
        this.showPurchaseDetail = true;
        document.getElementById("purchaseArrow").style.transform = "rotate(180deg)";
      } else {
        this.showPurchaseDetail = false;
        document.getElementById("purchaseArrow").style.transform = "rotate(0deg)";
      }
    },
    reset: function reset() {
      this.cardTabs = ["More", "About", "Episodes", "Overview"];
      this.checkContentType();
      this.activeTabName = "Overview";
      this.activeAboutTabName = "Trailers";
    },
    closeDetailCard: function closeDetailCard() {
      __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("closeAllArrow");
      this.closePopupEvent();
    },
    showArrow: function showArrow() {
      // setTimeout(() => {
      __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("show-" + this.category + "-" + this.cardContent.title + "-downarrow");
      // }, 100);
    },
    routeCard: function routeCard(content) {
      var status = content.contentstatus;
      if (status === "INACTIVE") return;
      if (!this.subscriberid) {
        var data = {
          popup: "PaymentPopup",
          contentid: this.cardContent.contentid
        };
        __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("LoginPopup", data);
      } else if (this.subscriberid && !this.purchaseDetails) {
        var _data = {
          content: this.cardContent
        };
        __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("PaymentPopup", _data);
      } else if (this.subscriberid && this.purchaseDetails) {
        __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("showPlayer", this.content);
      }
    },
    renderAboutTab: function renderAboutTab(tab) {
      this.activeAboutTabName = tab;
    },
    renderTab: function renderTab(tab) {
      this.activeTabName = tab;
    },
    checkContentType: function checkContentType() {
      if (this.cardContent.contenttype == "MOVIE") {
        var temp = this.cardTabs.filter(function (ele) {
          return ele != "Episodes";
        });
        this.cardTabs = temp;
      }
    },
    comaSeparatedNames: function comaSeparatedNames(names) {
      var length = names.length;
      var nameString = "";
      for (var index = 0; index < length; index++) {
        if (nameString) {
          nameString += " , " + names[index].castncrewname;
        } else {
          nameString = names[index].castncrewname;
        }
      }
      return nameString;
    },
    getCrew: function getCrew() {
      var _this4 = this;

      var castAndCrew = null;
      var castAndCrewList = [];
      if (!this.cardContent.castncrew) return castAndCrew;
      var castArray = this.cardContent.castncrew.filter(function (cr) {
        return cr.castncrewtype == "CAST";
      });
      var crewArray = this.cardContent.castncrew.filter(function (cr) {
        return cr.castncrewtype == "CREW";
      });
      if (castArray.length > 0) {
        var data = {
          role: "Starring",
          names: castArray
        };
        castAndCrewList.push(data);
      }
      if (crewArray.length > 0) {
        crewArray.forEach(function (element) {
          var index = castAndCrewList.findIndex(function (ele) {
            return ele.role === element.castncrewrole;
          });
          if (index > -1) {
            castAndCrewList[index].names.push(element);
          } else {
            var _data2 = {
              role: element.castncrewrole,
              names: [element]
            };
            castAndCrewList.push(_data2);
          }
        });
      }
      castAndCrewList.forEach(function (ele) {
        ele.names = _this4.comaSeparatedNames(ele.names);
      });
      return castAndCrewList;
    },
    fetchCardHeight: function fetchCardHeight() {
      if (this.isMobile()) {
        if (window.innerWidth < 1990) {
          this.cardHeight = 550;
          if (this.cardContent.description.length > 180) {
            this.cardHeight += 200;
          }
          if (this.getCrew() && this.getCrew().length > 2) {
            this.cardHeight += 120;
          }
        }
      } else {
        var bodyWidth = document.body.offsetWidth - 400;
        var cardHeight = Math.round(bodyWidth / (16 / 9));
        if (cardHeight) {
          this.cardHeight = cardHeight + (this.isTablet() ? 330 : 30);
          // this.cardHeight = cardHeight;
          if (this.cardContent.description.length > 190) {
            if (this.getCrew() && this.getCrew().length > 2) {
              this.cardHeight += 100;
            } else {
              this.cardHeight += 70;
            }
          }
        }
      }
    },
    getLanguage: function getLanguage() {
      var contentLanguage = "";

      this.cardContent.tags.forEach(function (element) {
        var str = element.includes("Lang");
        if (str) {
          var str2 = element.split("-");
          if (str2 && str2.length > 1) {
            contentLanguage = str2[1].split("|");
          }
        }
      });
      this.languages = contentLanguage;
    },
    getPoster: function getPoster(content, type) {
      if (content.posters.length) {
        var landscapeposters = content.posters.filter(function (pos) {
          return pos.orientation === type;
        });
        if (landscapeposters.length) {
          var posterIndex = landscapeposters.findIndex(function (pos) {
            return pos.quality === "HD";
          });
          if (posterIndex > -1) {
            return landscapeposters[posterIndex].url;
          } else {
            return landscapeposters[0].url;
          }
        }
      }
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Utility__["a" /* default */]]
});

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(306);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("58639521", content, true, {});

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".ml0[data-v-d2027960]{margin-left:0}.card-detail[data-v-d2027960]{margin:0;border-radius:5px}.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px}.card-detail-box-contain[data-v-d2027960]{width:100%;height:100%;background-size:cover;background-repeat:no-repeat}.content-close[data-v-d2027960]{cursor:pointer}.content-close img[data-v-d2027960]{right:2%;padding:15px;z-index:100;position:absolute;top:2%}.deatil-container[data-v-d2027960]{width:100%;height:100%}.tablink[data-v-d2027960]{background-color:#000;border:none;outline:none;cursor:pointer;padding:30px 10px;width:15%;float:right;text-transform:uppercase;color:hsla(0,0%,100%,.77);font-family:HelveticaNeueMedium;font-size:18px;font-weight:500;letter-spacing:.37px;line-height:25px}.card-tab-content[data-v-d2027960]{height:100%}.tabcontent[data-v-d2027960]{display:none;height:100%}.card-tab[data-v-d2027960]{bottom:0;position:absolute;right:0;width:100%;background:#000}.card-tab button[data-v-d2027960]:first-child{margin-right:3%}.activetabname span[data-v-d2027960]{padding-bottom:5px;border-bottom:2px solid;color:#fff}.activetab[data-v-d2027960]{display:block!important}.inactivetab[data-v-d2027960]{display:none}.tabstyle[data-v-d2027960]{background-color:rgba(0,0,0,.8)}.overview-class[data-v-d2027960]{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;background:-webkit-gradient(linear,left top,right top,color-stop(0,#000),color-stop(35%,#000),to(hsla(0,100%,83%,0)));background:linear-gradient(90deg,#000,#000 35%,hsla(0,100%,83%,0))}.overview-left[data-v-d2027960]{-webkit-box-flex:1.1;-ms-flex:1.1;flex:1.1;background-repeat:no-repeat;background-size:cover;margin-top:-20px}.overview-left[data-v-d2027960]:after{width:10%;background:-webkit-gradient(linear,left top,right top,from(#000),color-stop(#000),color-stop(#000),color-stop(#000),color-stop(#000),to(transparent));background:linear-gradient(90deg,#000,#000,#000,#000,#000,transparent)}.overview-left .overview-left-content[data-v-d2027960]{padding:5%}.overview-left .overview-left-content .starring[data-v-d2027960]{float:left;margin-right:5px;opacity:.8;color:#fff;font-family:ProximanovaSemibold;font-size:18px;line-height:28px}.overview-left .overview-left-content .castncrew[data-v-d2027960]{word-break:break-word;opacity:.8;color:#fff;font-family:ProximanovaRegular;font-size:16px;line-height:28px}.overview-left .overview-left-content .content-description[data-v-d2027960]{opacity:.8;color:#fff;font-family:ProximanovaRegular;font-size:16px;line-height:26px;margin:10px 0 20px}.overview-left .overview-left-content .detail-card-ioncs[data-v-d2027960]{margin:25px 0 10px}.overview-left .overview-left-content .detail-card-ioncs .card-share-btn[data-v-d2027960]{margin-right:15px}.overview-left .overview-left-content .detail-card-ioncs .buttonHover[data-v-d2027960]:hover{-webkit-transform:translateY(-2px);transform:translateY(-2px);-webkit-transition:.2s;transition:.2s}.overview-left .overview-left-content .card-book-btn[data-v-d2027960]{width:60%}.overview-left .overview-left-content .card-book-btn button[data-v-d2027960]{margin-top:5%;letter-spacing:.44px;line-height:29px}.movie-title[data-v-d2027960]{color:#fff;font-size:40px;font-weight:700;letter-spacing:.74px;line-height:49px;text-transform:uppercase;font-family:ProximanovaBold;word-break:break-word}.rating[data-v-d2027960]{display:-webkit-box;display:-ms-flexbox;display:flex;margin:10px 0}.rating-box[data-v-d2027960]{width:20px;height:20px;border:1px solid hsla(0,0%,100%,.77);margin-right:5px}.rating-no[data-v-d2027960]{opacity:.76;color:#fff;font-family:HelveticaNeueMedium;font-size:20px;line-height:24px;margin-top:-2px;margin-left:5px}.movie-tags[data-v-d2027960]{clear:both;display:table;margin:15px 0}.movie-tags p[data-v-d2027960]{float:left;opacity:.76;color:#fff;font-family:ProximanovaSemibold;font-size:18px;line-height:15px;margin-right:25px;text-transform:uppercase;margin-bottom:10px}.overview-right[data-v-d2027960]{-webkit-box-flex:1;-ms-flex:1;flex:1}.overview-right img.play[data-v-d2027960]{cursor:pointer;margin-top:40%;margin-left:40%;opacity:.85}.overview-right img.play[data-v-d2027960]:hover{opacity:1}.About-content[data-v-d2027960]{padding:5% 5% 0 8%}.abouttablink[data-v-d2027960]{text-transform:uppercase;letter-spacing:1px;background-color:transparent;padding:7px 20px;font-size:12px;font-weight:600;color:hsla(0,0%,100%,.77);border:1px solid hsla(0,0%,100%,.77);margin-right:5px;cursor:pointer;font-family:HelveticaNeueMedium}.aboutactivetab[data-v-d2027960]{color:#fff;border:2px solid #fff;font-size:14px;font-weight:700;line-height:19px}.about-tab[data-v-d2027960]{display:none;height:100%}.more-like-this[data-v-d2027960]{color:#fff;font-family:HelveticaNeueMedium;font-size:40px;letter-spacing:.74px;line-height:49px;text-transform:uppercase}.card-detail-progress[data-v-d2027960]{width:70%;height:2px;background-color:hsla(0,0%,65%,.5);margin:20px 0}.card-detail-progress .progress-percent[data-v-d2027960]{height:100%;background-color:#4558dd}.purchase-details .title[data-v-d2027960]{color:hsla(0,0%,100%,.55);font-family:ProximanovaSemibold;font-size:20px;letter-spacing:.44px;line-height:29px;float:left}.purchase-details .arrow[data-v-d2027960]{width:16px;margin-left:10px;margin-top:5px;cursor:pointer;-webkit-transition:.5s;transition:.5s}.purchase-details .label[data-v-d2027960]{color:hsla(0,0%,100%,.55);margin-right:15px}.purchase-details .label[data-v-d2027960],.purchase-details .value[data-v-d2027960]{font-family:ProximanovaSemibold;font-size:16px;letter-spacing:.44px;line-height:29px;float:left}.purchase-details .value[data-v-d2027960]{color:hsla(0,0%,100%,.8)}.slide-enter-active[data-v-d2027960]{-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-timing-function:ease-in;transition-timing-function:ease-in}.slide-leave-active[data-v-d2027960]{-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out}.slide-enter-to[data-v-d2027960],.slide-leave[data-v-d2027960]{max-height:100px;overflow:hidden}.slide-enter[data-v-d2027960],.slide-leave-to[data-v-d2027960]{overflow:hidden;max-height:0}.trailer-btn img[data-v-d2027960]{width:30px}.trailer-btn p[data-v-d2027960]{color:#fff;font-family:ProximanovaRegular;font-size:18px;font-weight:700;line-height:24px;text-align:center}@media only screen and (max-width:600px){.card-detail-box-contain[data-v-d2027960]{width:100%;height:100%;background-size:cover;background-repeat:no-repeat;background-position:50%}.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px;overflow:hidden}.overview-left[data-v-d2027960]{-webkit-box-flex:1;-ms-flex:1;flex:1;margin-top:0}.overview-left .overview-left-content .card-book-btn[data-v-d2027960]{width:95%;margin-bottom:20px}.overview-left .overview-left-content .card-book-btn button[data-v-d2027960]{font-size:20px}.overview-right[data-v-d2027960]{-webkit-box-flex:1;-ms-flex:1;flex:1}.overview-right img.play[data-v-d2027960]{cursor:pointer;width:60px;margin:0;position:absolute;top:40%;right:20%}.movie-tags p[data-v-d2027960]{margin-bottom:10px}.overview-right[data-v-d2027960]{-webkit-box-flex:0;-ms-flex:0;flex:0}.purchase-details[data-v-d2027960]{margin-bottom:20px}}@media only screen and (min-width:601px) and (max-width:992px){.overview-left[data-v-d2027960]{-webkit-box-flex:2.5;-ms-flex:2.5;flex:2.5}.card-book-btn[data-v-d2027960]{width:70%}.overview-right[data-v-d2027960]{position:relative}.overview-right img.play[data-v-d2027960]{cursor:pointer;width:60px;position:absolute;top:20%;right:40%}}@media only screen and (min-width:768px){.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px}}@media only screen and (min-width:992px){.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px;overflow:hidden}}@media only screen and (min-width:1200px){.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px;overflow:hidden}}@media screen and (min-width:1900px){.card-detail-box[data-v-d2027960]{height:675px!important;position:relative;border-radius:8px;overflow:hidden}.overview-left .overview-left-content .castncrew[data-v-d2027960],.overview-left .overview-left-content .content-description[data-v-d2027960],.overview-left .overview-left-content .starring[data-v-d2027960]{font-size:20px}.trailer-btn img[data-v-d2027960]{width:35px}.movie-tags p[data-v-d2027960]{font-size:20px}.overview-right img.play[data-v-d2027960]{margin-top:30%;margin-left:35%}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Templates/ContentDetailCard.vue"],"names":[],"mappings":"AACA,sBAAsB,aAAa,CAClC,AACD,8BAA8B,SAAa,iBAAiB,CAC3D,AACD,kCAAkC,kBAAkB,iBAAiB,CACpE,AACD,0CAA0C,WAAW,YAAY,sBAAsB,2BAA2B,CACjH,AACD,gCAAgC,cAAc,CAC7C,AACD,oCAAoC,SAAS,aAAa,YAAY,kBAAkB,MAAM,CAC7F,AACD,mCAAmC,WAAW,WAAW,CACxD,AACD,0BAA0B,sBAAuB,YAAY,aAAa,eAAe,kBAAkB,UAAU,YAAY,yBAAyB,0BAA6B,gCAAkC,eAAe,gBAAgB,qBAAsB,gBAAgB,CAC7R,AACD,mCAAmC,WAAW,CAC7C,AACD,6BAA6B,aAAa,WAAW,CACpD,AACD,2BAA2B,SAAS,kBAAkB,QAAQ,WAAW,eAAgB,CACxF,AACD,8CAA8C,eAAe,CAC5D,AACD,qCAAqC,mBAAmB,wBAAwB,UAAW,CAC1F,AACD,4BAA4B,uBAAwB,CACnD,AACD,8BAA8B,YAAY,CACzC,AACD,2BAA2B,+BAAgC,CAC1D,AACD,iCAAiC,oBAAoB,oBAAoB,aAAa,YAAY,sHAA8H,kEAAwE,CACvS,AACD,gCAAgC,qBAAqB,aAAa,SAAS,4BAA4B,sBAAsB,gBAAgB,CAC5I,AACD,sCAAuC,UAAU,sJAAiK,sEAAkF,CACnS,AACD,uDAAuD,UAAU,CAChE,AACD,iEAAiE,WAAW,iBAAiB,WAAY,WAAc,gCAAkC,eAAe,gBAAgB,CACvL,AACD,kEAAkE,sBAAsB,WAAY,WAAc,+BAAiC,eAAe,gBAAgB,CACjL,AACD,4EAA4E,WAAY,WAAc,+BAAiC,eAAe,iBAAiB,kBAAoB,CAC1L,AACD,0EAA0E,kBAAoB,CAC7F,AACD,0FAA0F,iBAAiB,CAC1G,AACD,6FAA6F,mCAAmC,2BAA2B,uBAAwB,cAAe,CACjM,AACD,sEAAsE,SAAS,CAC9E,AACD,6EAA6E,cAAc,qBAAsB,gBAAgB,CAChI,AACD,8BAA8B,WAAc,eAAe,gBAAiB,qBAAsB,iBAAiB,yBAAyB,4BAA8B,qBAAqB,CAC9L,AACD,yBAAyB,oBAAoB,oBAAoB,aAAa,aAAa,CAC1F,AACD,6BAA6B,WAAW,YAAY,qCAAwC,gBAAgB,CAC3G,AACD,4BAA4B,YAAa,WAAc,gCAAkC,eAAe,iBAAiB,gBAAgB,eAAe,CACvJ,AACD,6BAA6B,WAAW,cAAc,aAAa,CAClE,AACD,+BAA+B,WAAW,YAAa,WAAc,gCAAkC,eAAe,iBAAiB,kBAAkB,yBAAyB,kBAAkB,CACnM,AACD,iCAAiC,mBAAmB,WAAW,MAAM,CACpE,AACD,0CAA0C,eAAe,eAAe,gBAAgB,WAAY,CACnG,AACD,gDAAgD,SAAS,CACxD,AACD,gCAAgC,kBAAkB,CACjD,AACD,+BAA+B,yBAAyB,mBAAmB,6BAA6B,iBAAiB,eAAe,gBAAgB,0BAA6B,qCAAwC,iBAAiB,eAAe,+BAAiC,CAC7R,AACD,iCAAiC,WAAc,sBAAyB,eAAe,gBAAiB,gBAAgB,CACvH,AACD,4BAA4B,aAAa,WAAW,CACnD,AACD,iCAAiC,WAAc,gCAAkC,eAAe,qBAAsB,iBAAiB,wBAAwB,CAC9J,AACD,uCAAuC,UAAU,WAAW,mCAAuC,aAAa,CAC/G,AACD,yDAAyD,YAAY,wBAAwB,CAC5F,AACD,0CAA0C,0BAA6B,gCAAkC,eAAe,qBAAsB,iBAAiB,UAAU,CACxK,AACD,0CAA0C,WAAW,iBAAiB,eAAe,eAAe,uBAAwB,cAAe,CAC1I,AACD,0CAA0C,0BAA6B,AAAmG,iBAAiB,CAC1L,AACD,oFAFuE,gCAAkC,eAAe,qBAAsB,iBAAiB,UAAW,CAGzK,AADD,0CAA0C,wBAA4B,CACrE,AACD,qCAAqC,gCAAiC,wBAAyB,2CAA2C,kCAAkC,CAC3K,AACD,qCAAqC,gCAAiC,wBAAyB,4CAA4C,mCAAmC,CAC7K,AACD,+DAA+D,iBAAiB,eAAe,CAC9F,AACD,+DAA+D,gBAAgB,YAAY,CAC1F,AACD,kCAAkC,UAAU,CAC3C,AACD,gCAAgC,WAAc,+BAAiC,eAAe,gBAAiB,iBAAiB,iBAAiB,CAChJ,AACD,yCACA,0CAA0C,WAAW,YAAY,sBAAsB,4BAA4B,uBAA0B,CAC5I,AACD,kCAAkC,kBAAkB,kBAAkB,eAAe,CACpF,AACD,gCAAgC,mBAAmB,WAAW,OAAO,YAAc,CAClF,AACD,sEAAsE,UAAU,kBAAkB,CACjG,AACD,6EAA6E,cAAc,CAC1F,AACD,iCAAiC,mBAAmB,WAAW,MAAM,CACpE,AACD,0CAA0C,eAAe,WAAW,SAAW,kBAAkB,QAAQ,SAAS,CACjH,AACD,+BAA+B,kBAAkB,CAChD,AACD,iCAAiC,mBAAmB,WAAW,MAAM,CACpE,AACD,mCAAmC,kBAAkB,CACpD,CACA,AACD,+DACA,gCAAgC,qBAAqB,aAAa,QAAQ,CACzE,AACD,gCAAgC,SAAS,CACxC,AACD,iCAAiC,iBAAiB,CACjD,AACD,0CAA0C,eAAe,WAAW,kBAAkB,QAAQ,SAAS,CACtG,CACA,AACD,yCACA,kCAAkC,kBAAkB,iBAAiB,CACpE,CACA,AACD,yCACA,kCAAkC,kBAAkB,kBAAkB,eAAe,CACpF,CACA,AACD,0CACA,kCAAkC,kBAAkB,kBAAkB,eAAe,CACpF,CACA,AACD,qCACA,kCAAkC,uBAAwB,kBAAkB,kBAAkB,eAAe,CAC5G,AAKD,+MAA4E,cAAc,CACzF,AACD,kCAAkC,UAAU,CAC3C,AACD,+BAA+B,cAAc,CAC5C,AACD,0CAA0C,eAAe,eAAe,CACvE,CACA","file":"ContentDetailCard.vue","sourcesContent":["\n.ml0[data-v-d2027960]{margin-left:0\n}\n.card-detail[data-v-d2027960]{margin:0 0px;border-radius:5px\n}\n.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px\n}\n.card-detail-box-contain[data-v-d2027960]{width:100%;height:100%;background-size:cover;background-repeat:no-repeat\n}\n.content-close[data-v-d2027960]{cursor:pointer\n}\n.content-close img[data-v-d2027960]{right:2%;padding:15px;z-index:100;position:absolute;top:2%\n}\n.deatil-container[data-v-d2027960]{width:100%;height:100%\n}\n.tablink[data-v-d2027960]{background-color:black;border:none;outline:none;cursor:pointer;padding:30px 10px;width:15%;float:right;text-transform:uppercase;color:rgba(255,255,255,0.77);font-family:\"HelveticaNeueMedium\";font-size:18px;font-weight:500;letter-spacing:0.37px;line-height:25px\n}\n.card-tab-content[data-v-d2027960]{height:100%\n}\n.tabcontent[data-v-d2027960]{display:none;height:100%\n}\n.card-tab[data-v-d2027960]{bottom:0;position:absolute;right:0;width:100%;background:black\n}\n.card-tab button[data-v-d2027960]:first-child{margin-right:3%\n}\n.activetabname span[data-v-d2027960]{padding-bottom:5px;border-bottom:2px solid;color:white\n}\n.activetab[data-v-d2027960]{display:block !important\n}\n.inactivetab[data-v-d2027960]{display:none\n}\n.tabstyle[data-v-d2027960]{background-color:rgba(0,0,0,0.8)\n}\n.overview-class[data-v-d2027960]{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;background:-webkit-gradient(linear, left top, right top, color-stop(0, #000), color-stop(35%, #000), to(rgba(255,166,166,0)));background:linear-gradient(90deg, #000 0, #000 35%, rgba(255,166,166,0))\n}\n.overview-left[data-v-d2027960]{-webkit-box-flex:1.1;-ms-flex:1.1;flex:1.1;background-repeat:no-repeat;background-size:cover;margin-top:-20px\n}\n.overview-left[data-v-d2027960]::after{width:10%;background:-webkit-gradient(linear, left top, right top, from(black), color-stop(#000), color-stop(#000), color-stop(#000), color-stop(#000), to(rgba(0,0,0,0)));background:linear-gradient(to right, black, #000, #000, #000, #000, rgba(0,0,0,0))\n}\n.overview-left .overview-left-content[data-v-d2027960]{padding:5%\n}\n.overview-left .overview-left-content .starring[data-v-d2027960]{float:left;margin-right:5px;opacity:0.8;color:#ffffff;font-family:\"ProximanovaSemibold\";font-size:18px;line-height:28px\n}\n.overview-left .overview-left-content .castncrew[data-v-d2027960]{word-break:break-word;opacity:0.8;color:#ffffff;font-family:\"ProximanovaRegular\";font-size:16px;line-height:28px\n}\n.overview-left .overview-left-content .content-description[data-v-d2027960]{opacity:0.8;color:#ffffff;font-family:\"ProximanovaRegular\";font-size:16px;line-height:26px;margin:10px 0 20px 0\n}\n.overview-left .overview-left-content .detail-card-ioncs[data-v-d2027960]{margin:25px 0 10px 0\n}\n.overview-left .overview-left-content .detail-card-ioncs .card-share-btn[data-v-d2027960]{margin-right:15px\n}\n.overview-left .overview-left-content .detail-card-ioncs .buttonHover[data-v-d2027960]:hover{-webkit-transform:translateY(-2px);transform:translateY(-2px);-webkit-transition:0.2s;transition:0.2s\n}\n.overview-left .overview-left-content .card-book-btn[data-v-d2027960]{width:60%\n}\n.overview-left .overview-left-content .card-book-btn button[data-v-d2027960]{margin-top:5%;letter-spacing:0.44px;line-height:29px\n}\n.movie-title[data-v-d2027960]{color:#ffffff;font-size:40px;font-weight:bold;letter-spacing:0.74px;line-height:49px;text-transform:uppercase;font-family:\"ProximanovaBold\";word-break:break-word\n}\n.rating[data-v-d2027960]{display:-webkit-box;display:-ms-flexbox;display:flex;margin:10px 0\n}\n.rating-box[data-v-d2027960]{width:20px;height:20px;border:1px solid rgba(255,255,255,0.77);margin-right:5px\n}\n.rating-no[data-v-d2027960]{opacity:0.76;color:#ffffff;font-family:\"HelveticaNeueMedium\";font-size:20px;line-height:24px;margin-top:-2px;margin-left:5px\n}\n.movie-tags[data-v-d2027960]{clear:both;display:table;margin:15px 0\n}\n.movie-tags p[data-v-d2027960]{float:left;opacity:0.76;color:#ffffff;font-family:\"ProximanovaSemibold\";font-size:18px;line-height:15px;margin-right:25px;text-transform:uppercase;margin-bottom:10px\n}\n.overview-right[data-v-d2027960]{-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.overview-right img.play[data-v-d2027960]{cursor:pointer;margin-top:40%;margin-left:40%;opacity:0.85\n}\n.overview-right img.play[data-v-d2027960]:hover{opacity:1\n}\n.About-content[data-v-d2027960]{padding:5% 5% 0 8%\n}\n.abouttablink[data-v-d2027960]{text-transform:uppercase;letter-spacing:1px;background-color:transparent;padding:7px 20px;font-size:12px;font-weight:600;color:rgba(255,255,255,0.77);border:1px solid rgba(255,255,255,0.77);margin-right:5px;cursor:pointer;font-family:\"HelveticaNeueMedium\"\n}\n.aboutactivetab[data-v-d2027960]{color:#ffffff;border:2px solid #ffffff;font-size:14px;font-weight:bold;line-height:19px\n}\n.about-tab[data-v-d2027960]{display:none;height:100%\n}\n.more-like-this[data-v-d2027960]{color:#ffffff;font-family:\"HelveticaNeueMedium\";font-size:40px;letter-spacing:0.74px;line-height:49px;text-transform:uppercase\n}\n.card-detail-progress[data-v-d2027960]{width:70%;height:2px;background-color:rgba(167,167,167,0.5);margin:20px 0\n}\n.card-detail-progress .progress-percent[data-v-d2027960]{height:100%;background-color:#4558dd\n}\n.purchase-details .title[data-v-d2027960]{color:rgba(255,255,255,0.55);font-family:\"ProximanovaSemibold\";font-size:20px;letter-spacing:0.44px;line-height:29px;float:left\n}\n.purchase-details .arrow[data-v-d2027960]{width:16px;margin-left:10px;margin-top:5px;cursor:pointer;-webkit-transition:0.5s;transition:0.5s\n}\n.purchase-details .label[data-v-d2027960]{color:rgba(255,255,255,0.55);font-family:\"ProximanovaSemibold\";font-size:16px;letter-spacing:0.44px;line-height:29px;float:left;margin-right:15px\n}\n.purchase-details .value[data-v-d2027960]{color:rgba(255,255,255,0.8);font-family:\"ProximanovaSemibold\";font-size:16px;letter-spacing:0.44px;line-height:29px;float:left\n}\n.slide-enter-active[data-v-d2027960]{-webkit-transition-duration:0.2s;transition-duration:0.2s;-webkit-transition-timing-function:ease-in;transition-timing-function:ease-in\n}\n.slide-leave-active[data-v-d2027960]{-webkit-transition-duration:0.2s;transition-duration:0.2s;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out\n}\n.slide-enter-to[data-v-d2027960],.slide-leave[data-v-d2027960]{max-height:100px;overflow:hidden\n}\n.slide-enter[data-v-d2027960],.slide-leave-to[data-v-d2027960]{overflow:hidden;max-height:0\n}\n.trailer-btn img[data-v-d2027960]{width:30px\n}\n.trailer-btn p[data-v-d2027960]{color:#ffffff;font-family:\"ProximanovaRegular\";font-size:18px;font-weight:bold;line-height:24px;text-align:center\n}\n@media only screen and (max-width: 600px){\n.card-detail-box-contain[data-v-d2027960]{width:100%;height:100%;background-size:cover;background-repeat:no-repeat;background-position:center\n}\n.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px;overflow:hidden\n}\n.overview-left[data-v-d2027960]{-webkit-box-flex:1;-ms-flex:1;flex:1;margin-top:0px\n}\n.overview-left .overview-left-content .card-book-btn[data-v-d2027960]{width:95%;margin-bottom:20px\n}\n.overview-left .overview-left-content .card-book-btn button[data-v-d2027960]{font-size:20px\n}\n.overview-right[data-v-d2027960]{-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.overview-right img.play[data-v-d2027960]{cursor:pointer;width:60px;margin:0px;position:absolute;top:40%;right:20%\n}\n.movie-tags p[data-v-d2027960]{margin-bottom:10px\n}\n.overview-right[data-v-d2027960]{-webkit-box-flex:0;-ms-flex:0;flex:0\n}\n.purchase-details[data-v-d2027960]{margin-bottom:20px\n}\n}\n@media only screen and (min-width: 601px) and (max-width: 992px){\n.overview-left[data-v-d2027960]{-webkit-box-flex:2.5;-ms-flex:2.5;flex:2.5\n}\n.card-book-btn[data-v-d2027960]{width:70%\n}\n.overview-right[data-v-d2027960]{position:relative\n}\n.overview-right img.play[data-v-d2027960]{cursor:pointer;width:60px;position:absolute;top:20%;right:40%\n}\n}\n@media only screen and (min-width: 768px){\n.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px\n}\n}\n@media only screen and (min-width: 992px){\n.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px;overflow:hidden\n}\n}\n@media only screen and (min-width: 1200px){\n.card-detail-box[data-v-d2027960]{position:relative;border-radius:8px;overflow:hidden\n}\n}\n@media screen and (min-width: 1900px){\n.card-detail-box[data-v-d2027960]{height:675px !important;position:relative;border-radius:8px;overflow:hidden\n}\n.overview-left .overview-left-content .starring[data-v-d2027960]{font-size:20px\n}\n.overview-left .overview-left-content .castncrew[data-v-d2027960]{font-size:20px\n}\n.overview-left .overview-left-content .content-description[data-v-d2027960]{font-size:20px\n}\n.trailer-btn img[data-v-d2027960]{width:35px\n}\n.movie-tags p[data-v-d2027960]{font-size:20px\n}\n.overview-right img.play[data-v-d2027960]{margin-top:30%;margin-left:35%\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-detail",attrs:{"id":(_vm.category + "-" + (_vm.cardContent.contentid))}},[_c('div',{staticClass:"card-detail-box"},[_c('div',{staticClass:"card-detail-box-contain",style:({
            'background-image': ("url(" + (_vm.getPoster(_vm.cardContent,'LANDSCAPE')) + ")")
          })},[_c('div',{staticClass:"deatil-container"},[_c('div',{staticClass:"content-close"},[_c('img',{staticClass:"header-close",attrs:{"src":__webpack_require__(309),"alt":"closes"},on:{"click":function($event){return _vm.closeDetailCard()}}})]),_vm._v(" "),_c('div',{staticClass:"card-tab-content"},[_c('div',{staticClass:"tabcontent",class:'Overview' === _vm.activeTabName ? 'activetab' : '',attrs:{"id":_vm.cardContent.title+'Overview'}},[_c('div',{staticClass:"overview-class"},[_c('div',{staticClass:"overview-left"},[_c('div',{staticClass:"overview-left-content"},[_c('p',{staticClass:"movie-title"},[_vm._v(_vm._s(_vm.cardContent.title))]),_vm._v(" "),(_vm.progress && _vm.purchaseDetails)?_c('div',{staticClass:"card-detail-progress"},[_c('div',{staticClass:"progress-percent",style:({ width: _vm.progress + '%' }),attrs:{"id":("progress-" + (_vm.cardContent.contentid))}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"movie-tags"},[_c('p',[_vm._v(_vm._s(_vm.cardContent.category))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cardContent.year))]),_vm._v(" "),_vm._l((_vm.languages),function(lang,index){return _c('p',{key:lang,style:((index != 0) ? 'padding-left: 10px;border-left:1.5px solid rgba(255, 252, 252, 0.76);margin-right:10px;': 'margin-right:10px;')},[_vm._v(_vm._s(lang))])})],2),_vm._v(" "),_vm._l((_vm.getCrew()),function(castandcrew,index){return _c('div',{key:index},[_c('p',{staticClass:"starring"},[_vm._v(_vm._s(castandcrew.role)+" :")]),_vm._v(" "),_c('p',{staticClass:"castncrew"},[_vm._v(_vm._s(castandcrew.names))])])}),_vm._v(" "),(_vm.cardContent.description)?_c('p',{staticClass:"content-description"},[_vm._v(_vm._s(_vm.cardContent.description))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"detail-card-ioncs row"},[_c('div',{staticClass:"col-lg-2 col-md-2 col-sm-3 buttonHover"},[_c('div',{staticClass:"trailer-btn"},[_c('button',{staticClass:"watchlist-btn",staticStyle:{"background":"black","border":"none"},attrs:{"type":"button"},on:{"click":_vm.watchTrailer}},[_c('img',{attrs:{"src":__webpack_require__(310),"alt":"watchlist"}}),_vm._v(" "),_c('p',{staticClass:"like-tag",staticStyle:{"color":"white"}},[_vm._v("Trailer")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-2 col-sm-3 buttonHover"},[_c('Share',{staticClass:"card-share-btn",attrs:{"content":_vm.cardContent}})],1)]),_vm._v(" "),(!_vm.purchaseDetails && _vm.showPurchaseButton)?_c('div',{staticClass:"card-book-btn"},[_c('button',{ref:"bookNowBtn",staticClass:"btn-lg-primary",on:{"click":function($event){return _vm.routeCard(_vm.cardContent)}}},[_vm._v(_vm._s((_vm.purchaseDetails && _vm.subscriberid) ? 'Watch Now' : ("Purchase for " + (_vm.contentPrice.currencysymbol) + " " + (_vm.contentPrice.amount / 100))))])]):_vm._e(),_vm._v(" "),(_vm.purchaseDetails)?_c('div',{staticClass:"purchase-details"},[_c('div',{staticClass:"row ml0"},[_c('p',{staticClass:"title"},[_vm._v("Purchase Details")]),_vm._v(" "),_c('img',{staticClass:"arrow",attrs:{"id":"purchaseArrow","src":__webpack_require__(252)},on:{"click":_vm.toggleDetails}})]),_vm._v(" "),(_vm.showPurchaseDetail)?_c('transition',{attrs:{"name":"slide"}},[_c('div',[_c('div',{staticClass:"row ml0"},[_c('p',{staticClass:"label"},[_vm._v("Expires on")]),_vm._v(" "),_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.formateDate()))])]),_vm._v(" "),_c('div',{staticClass:"row ml0"},[_c('p',{staticClass:"label"},[_vm._v("Transaction ID-")]),_vm._v(" "),_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.cardContent.purchaseDetails.ticketid))])]),_vm._v(" "),_c('div',{staticClass:"row ml0"},[_c('p',{staticClass:"label"},[_vm._v("Total Amount Paid")]),_vm._v(" "),_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.contentPrice.currencysymbol)+_vm._s(_vm.cardContent.purchaseDetails.ticketprice / 100))])])])]):_vm._e()],1):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"overview-right"},[(_vm.purchaseDetails)?_c('img',{staticClass:"play",attrs:{"src":__webpack_require__(203),"width":"20%"},on:{"click":function($event){$event.preventDefault();return _vm.playContent(_vm.cardContent)}}}):_vm._e()])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAAGXcA1uAAAABGdBTUEAALGPC/xhBQAAA5xJREFUSA2NlU1IlFEUhr+ZMdOy1CxSC6KECKekjYGpLYp+DDcRFhQUZYtZtbKFkFKE6EZctkncuHEZCUW4EhFEF7NQQnCgQEErSYmYpplxep/rd4c7w2gdeOeee/7vuee743meFxCg7bW3t/e+Ni3sQLMEJ7y1tbVT2nirq6snWcsymcxvrUUBmEAgUD01NXUGTaivr+/O9PT0RfFGqbUBBWQEkUjk6cTEROu2yPOCYnAt8gVlWk95ClEqBqWhubm5fWLMvtbPHhoaGqpYWFh4IQVKU3AY5fz8/EvtaxAa6u/vr5yZmRmwnkY4MDBQ7lvWSmA8tYZQHhGOwojoQ51AQV5wfHz8LGEUrkl7Y41CFKAgdMvLyxHtS4xQP/uFelqLcnJysrm7u7sK3k/fIn21YHsgdjttWTgcbsQQ+Hdz3DW0DSJ1uYy+j42NtetCbgpX0ul0ULIlNfOCnLKlBkdGRs7Pzs4+k5DU9InUHJT2h3t6eu5J3ym+FCHAgGwpIS24hH6PwJpEEUylUg+12qjIXEL/QIJsSSWqcwVISJ+JZCm0tbX1QTom7pBgzsyFNxRwco0vyYabNQ6kosctjlOZE/madPUCd5Ul6qc71sncg/YYhwW6ZUq190B3vgmfE4nEJ63QuvBV+CL8EjJCDrk1P3bK44xuI4yTa3xDkmbhsuOU0z3X2NZcIQe6Ys9Ey82kcobiZDKZ0uy0i0dBzZsC9cckv6tzRcUTJEhtpKND8GuCe0C6VyVUCjRhHSOyMCt0gVnJ7wb3hOOWrzeRi+Lx+CMdkv6vLC4uNkq5V8CYoDsRutDo6OhB+b3HXxf+VjKqzs4mQWh1zfDwcBsJMGT13zGM8xOZwHzudoLwWVpaei7bemIJTJKZC36oll6cFpr8p6BQIqoqyg/sPxNX8fVjEIuY2dPD4MxIkp3xbMlPpLfnuluxH5jR4CHAB19iZNsjPocKJWodHBxkcs33waoX8LW82gRe+v8KnJNFG9O2jo6OY5rJjzZ4LBZ7Iz7bOu5MtocF2mH6rXVXKnh50Wj0lbxuCbdBV1dXp5tol2HIJisY2OkxreDfsM7HOa2t+Xe0UyKCF29sbDyxrXAC518eHxjYcRjU0nfS82UWCwFTuRgegnKBd/aAwFf4U/jhr7zBvP72q3X9sCcgK3KegnVhU4gjAIwVF2UviwczIfwR3MDa5pBNRLX4Eofi8AUpDCy5PDJbrdX/ay3o/xcOelNOLOOTTwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// static/js/37.bbae0ebd58a99047185f.js